"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { Globe, PhoneCall, MapPin, Mail } from "lucide-react";
import Image from "next/image";
import { TextRevealCard } from "./ui/text-reveal-card";

interface FooterLink {
    name: string;
    href: string;
}
const footerLinks: FooterLink[] = [
    { name: "Home", href: "#home" },
    { name: "About Me", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Requirement Form", href: "#form" },
];

export default function Footer() {
    const currentYear = new Date().getFullYear();
    const pathname = usePathname();
    const router = useRouter();

    const handleLinkClick = (
        e: React.MouseEvent<HTMLAnchorElement>,
        href: string
    ) => {
        e.preventDefault();
        if (href.startsWith("#")) {
            const sectionId = href.substring(1);
            if (pathname === "/") {
                const element = document.getElementById(sectionId);
                if (element) {
                    const desktopNav = document.querySelector(".md\\:flex.hidden") as HTMLElement;
                    const mobileNav = document.querySelector(".md\\:hidden.flex") as HTMLElement;
                    let navHeight = 0;

                    if (window.innerWidth < 768 && mobileNav) {
                        navHeight = mobileNav.clientHeight;
                    } else if (desktopNav) {
                        navHeight = desktopNav.clientHeight;
                    }

                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = element.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - navHeight;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                }
            } else {
                router.push("/" + href);
            }
        } else {
            router.push(href);
        }

    };

    return (
        <div className="bg-[#131313] bg-cover bg-center relative bg-no-repeat ">
            {/* <img
        src="/images/footer_bg.webp"
        alt="Background"
        className="bg-no-repeat bg-center object-cover object-center
       h-full w-full absolute inset-0 z-[-1]"
      /> */}
            <div className="px-[5%] mb-[-5vw]">
                <div className="w-full flex flex-col md:flex-row justify-between">
                    <div className="w-full md:w-[30%] mt-10 md:mt-[3vw] mx-auto md:mx-0">
                        <Link href="/" onClick={(e) => handleLinkClick(e, "#home")}>
                            <img
                                src="/logo.webp"
                                alt="Logo"
                                className="mx-auto md:mx-0 w-full md:w-[70%]"
                            /></Link>
                        <p className="text-[#E2E8F0] text-sm sm:text-[1.1vw] mt-4 md:my-[2vw] text-center md:text-left">Premium DJ, Singer, Keyboardist, and Live Entertainer
                            Delivering Unforgettable Event Experiences
                            Across Canada.
                        </p>
                    </div>

                    <div className="w-full md:w-[52%] mt-6 md:mt-[4vw] flex flex-col md:flex-row justify-between mx-auto md:mx-0">
                        {/* Quick Links */}
                        <div>
                            <h1 className="text-xl md:text-[1.7vw] mt-4 lg:mt-0 text-white text-center md:text-left">
                                Quick Links
                            </h1>
                            <ul className="flex items-center md:items-start flex-col mt-1 md:mt-[1vw] gap-1 sm:gap-[0.4vw]">
                                {footerLinks.map((link, index) => (
                                    <li key={index}>
                                        <Link
                                            href={link.href}
                                            onClick={(e) => handleLinkClick(e, link.href)}
                                            className="relative z-10 text-white lg:text-[1.1vw] rounded-full transition-all duration-300 whitespace-nowrap hover:underline hover:text-[#00C5FF]"
                                        >
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Contact us */}
                        <div className=" text-white text-center md:text-left flex flex-col">
                            <div>
                                <h1 className="text-xl md:text-[1.7vw] mt-7 lg:mt-0">
                                    Contact Info
                                </h1>

                                {/* Mail */}
                                <div className="flex items-center justify-center md:justify-start gap-2 mt-1 md:mt-[1vw] mb-2 md:mb-0">
                                    <Mail className="text-[#FFBAE3] size-5 md:size-[1.1vw]" />
                                    <Link
                                        href="mailto:sachinjoshi197809@gmail.com"
                                        className="lg:text-[1.1vw]"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        sachinjoshi197809@gmail.com
                                    </Link>
                                </div>

                                {/* Phone */}
                                <div className="flex items-center justify-center md:justify-start gap-2 mt-1 md:mt-[1vw] mb-2 md:mb-0">
                                    <PhoneCall className="text-[#FFBAE3] size-5 md:size-[1.1vw]" />
                                    <Link
                                        href="tel:+16472063523"
                                        className="lg:text-[1.1vw]"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        +1 (647) 206-3523
                                    </Link>
                                </div>

                                {/* Location */}
                                {/* <div className="flex items-center justify-center md:justify-start gap-2 mt-1 md:mt-[1vw] mb-2 md:mb-0">
                                    <MapPin className="text-white size-5 md:size-[1.1vw]" />
                                    <a
                                        href="#"
                                        className="lg:text-[0.9vw]"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        10915 104A Ave, Grande Prairie, AB T8V 8J6
                                    </a>
                                </div> */}

                            </div>
                        </div>


                        {/* Social Links */}
                        <div className=" text-white text-center md:text-left flex flex-col">
                            <div>
                                <h1 className="text-xl md:text-[1.7vw] mt-7 lg:mt-0">
                                    Social Links
                                </h1>

                                <div className="flex items-center md:justify-start justify-center gap-1 md:gap-[0.5vw] mt-1 md:mt-[1vw] mb-2 md:mb-0">
                                    <Link href="https://www.instagram.com/dj_sachin_2023/" className="cursor-pointer" target="_blank" aria-label="Visit DJ Sachin's Instagram page">
                                        <Image src={"/insta.svg"} alt="Instagram" width={100} height={100} className="w-7.5 h-7.5 md:w-[1.6vw] md:h-[1.6vw] transition-all duration-300 ease-in hover:drop-shadow-[0_0_5px_#FF004D] bg-transparent" />
                                    </Link>

                                    {/* <Link href="#" className="cursor-pointer" >
                                        <Image src={"/yt.svg"} alt="Youtube" width={100} height={100} className="w-10 h-10 md:w-[2vw] md:h-[2vw] transition-all duration-300 ease-in hover:drop-shadow-[0_0_5px_#FF004D] bg-transparent" />
                                    </Link> */}

                                    <Link href="https://www.facebook.com/share/1E2bWfzme6/?mibextid=wwXIfr" className="cursor-pointer" target="_blank" aria-label="Visit DJ Sachin's Facebook page">
                                        <Image src={"/fb.svg"} alt="Facebook" width={100} height={100} className="w-7.5 h-7.5 md:w-[1.6vw] md:h-[1.6vw] transition-all duration-300 ease-in hover:drop-shadow-[0_0_5px_#FF004D] bg-transparent" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <TextRevealCard className="leading-[0.8] whitespace-nowrap"
                text="DJ SACHIN"
                revealText="DJ SACHIN"
            />

            <div className="w-fullflex flex-col-reverse md:flex-row justify-between bg-black">
                <div className="relative text-white p-1 sm:px-6 w-full md:w-[28%] bg-gradient-to-t from-[#4c0883] to-[#d673e0]  md:[clip-path:polygon(0%_0%,80%_0%,100%_100%,0%_100%)] text-center md:text-left">
                    <Link
                        href="https://mantracollab.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="inline-block font-semibold text-sm md:text-[1vw] text-center transition-all duration-300  hover:scale-105">
                            {currentYear} © Powered by Mantra Collab
                        </span>
                    </Link>
                </div>
            </div>


        </div>
    );
}
